(function (angular) {
	'use strict';

	var ctaObject = {
		templateUrl: [
			'$attrs',
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		bindings: {
			destination: '<?',
			feeWaiver: '@?',
			mobileCampaign: '<?',
			referralKey: '<?',
			requireEmail: '<',
			text: '@',
			textCssClass: '@?'
		},
		controller: [
			'$httpParamSerializer',
			'$scope',
			'$timeout',
			'$window',
			'addToWaitlistFactory',
			'localStorageFactory',
			'APP_BASE_PATH',
			CampaignCtaFunction
		],
		controllerAs: 'cta'
	};

	angular
		.module('campaignCtaModule')
		.component('campaignCta', ctaObject);

	function templateUrlFunction(
		$attrs,
		STATIC_BASE_PATH) {
		if ($attrs.mobileCampaign) {
			return STATIC_BASE_PATH + '/static/html/campaigns/shared/mobile-campaign-cta.component.html';
		} else {
			return STATIC_BASE_PATH + '/static/html/campaigns/shared/campaign-cta.component.html';
		}
	}

	function CampaignCtaFunction(
		$httpParamSerializer,
		$scope,
		$timeout,
		$window,
		addToWaitlistFactory,
		localStorageFactory,
		APP_BASE_PATH) {
		
		var cta = this;

		cta.$onInit = function () {
			cta.formSubmitted = false;
			cta.showInvalidMessage = false;

			if(localStorageFactory.getItem("emailcapture") && !angular.isDefined(cta.feeWaiver)) {
				cta.requireEmail = false;
			}

			if (angular.isUndefined(cta.textCssClass)){
				cta.textCssClass = 'delta gamma-md';
			}
		};

		cta.previewYourPortfolio = function() {
			if (!cta.email) {
				cta.showInvalidMessage = true;
			} else if (cta.email && !cta.formSubmitted){
				cta.formSubmitted = true;
				$timeout(function() {
					addToWaitlistFactory.addToWaitlist(cta.email, cta.feeWaiver, cta.referralKey).then(function(response){
						redirectAfterWaitlistAdd(response);
					}, function(){
						redirectAfterWaitlistAdd();
					});
				},200);
			}
		};
		
		function redirectAfterWaitlistAdd(response){
			$scope.$emit('cta:emailSubmitted');
			
			if(angular.isDefined(cta.destination)) {
				var destination = cta.destination;
				
				if(response && response.data) {
					var params = {};
					var data = response.data;

					if($window.navigator.userAgent && $window.navigator.userAgent.indexOf('iPhone') > -1) {
						destination = APP_BASE_PATH + '/iphone-test';
					}
					
					if(data.emailAdded) {
						params.new_lead = data.emailAdded;
					} else if(data.mixpanelId !== null && data.mixpanelId !== undefined) {
						params.distinct_id = data.mixpanelId;
					}
					
					if(destination.indexOf('?') === -1) {
						destination = destination + '?' + $httpParamSerializer(params);
					}
					else {
						destination = destination + '&' + $httpParamSerializer(params);
					}
				}
				$window.location.href = destination;
			}
		}
	}
})(window.angular);
